import { apiFetch } from './apiClient';

/* Endereço pelo CEP (Correios). O backend escolhe o provedor e devolve já
   com o código do IBGE do município, que é o que a nota fiscal exige. */
export const buscarCep = (cep) => apiFetch(`/cep/${String(cep).replace(/\D/g, '')}`);
